import { ManagedElement, ManagedElementConnectEvent } from '../../../base/elements';
/**
 * Fired when connecting a new controls manager with the `MediaControllerElement`.
 *
 * @bubbles
 * @composed
 */
export class ManagedControlsConnectEvent extends ManagedElementConnectEvent {
}
ManagedControlsConnectEvent.TYPE = 'vds-managed-controls-connect';
export class ManagedControls extends ManagedElement {
    static get _ScopedDiscoveryEvent() {
        return ManagedControlsConnectEvent;
    }
}
